import * as TotalSummaryActions from '../actions/booking-total-summary.actions';
import * as TotalSummaryState from '../states/booking-total-summary.state';

export class State extends TotalSummaryState.State { }

const initialState: TotalSummaryState.State = TotalSummaryState.initialState;

/**
 * Reducer for the total summary component
 *
 * @export
 * @param {*} [state=initialState]
 * @param {TotalSummaryActions.Actions} action
 * @returns {TotalSummaryState.State}
 */
export function reducer(state = initialState, action: TotalSummaryActions.Actions): TotalSummaryState.State {

	switch (action.type) {
		case TotalSummaryActions.ActionTypes.LOADING:
			state = Object.assign({}, state, { loading: true });
			return state;
		case TotalSummaryActions.ActionTypes.PUT_ITENS_SUMMARY:
			state = Object.assign({}, state, { loading: false, payload: action.payload });
			return state;
		case TotalSummaryActions.ActionTypes.RESET:
			state = Object.assign({}, state, initialState);
			return state;
		default:
			return state;
	}
}

export const getLoading = (state: TotalSummaryState.State) => state.loading;
export const getFlightsSummary = (state: TotalSummaryState.State) => state.payload.flights;
export const getItensSummary = (state: TotalSummaryState.State) => state.payload.summary;
export const getTotalSummary = (state: TotalSummaryState.State) => state.payload.summary.reduce((acc, cur) => acc += parseFloat(cur.value), 0).toFixed(2);
